import { Button } from "react-bootstrap";
import BlockContainer from "../components/BlockContainer";
import { ICON_ANSWER, ICON_UPLOAD } from "../components/icons";


const [TYPE_SYSTEM, TYPE_VISA, TYPE_MAOLAM] = ['หมวดระบบแดนมังกร', 'หมวดวีซ่า', 'หมวดการเดินทางกับเที่ยวบินเหมาลำ']
const QuestionList = [
    {
        type : TYPE_SYSTEM,
        question : "เข้าสู่ระบบไม่ได้ ข้อความขึ้นว่า auth/user-not-found ต้องทำอย่างไร",
        answer : "ใช้อีเมลเดียวกับที่กรอกแบบฟอร์มในการเข้าสู่ระบบ",
    },
    {
        type : TYPE_SYSTEM,
        question : "เข้าสู่ระบบไม่ได้ ข้อความขึ้นว่า auth/wrong-password ต้องทำอย่างไร",
        answer : "หมายเลขหนังสือเดินทางไม่ตรงกับที่กรอกในแบบฟอร์ม",
    },
    {
        type : TYPE_SYSTEM,
        question : "เข้าสู่ระบบไม่ได้ ข้อความขึ้นว่า auth/too-many-requests ต้องทำอย่างไร",
        answer : "ผู้ใช้งาน ณ ขณะเดียวกันเกินกว่าที่ระบบประมวลผลทัน หรือผู้ใช้กรอกรหัสผ่านผิดเยอะเกินไป กรุณารอสักครู่",
    },
    {
        type : TYPE_SYSTEM,
        question : "เพิ่มเลขลำดับอย่างไร",
        answer : <span>ทำตามขั้นตอนต่อไปนี้ <a target='_blank' rel="noreferrer" href='https://scribehow.com/shared/__sepPhREvRJa5_kmVhVlX-A'>คลิก</a></span> ,
    },
    {
        type : TYPE_SYSTEM,
        question : "อัปโหลดไฟล์แล้วทำไมไม่ขึ้นในระบบ",
        answer : <span>คุณอาจจะไม่ได้กดปุ่ม <Button variant="light">{ICON_UPLOAD}</Button> เมื่ออัพโหลดไฟล์แล้ว</span>,
    },
    {
        type : TYPE_VISA,
        question : "แบบฟอร์มกรอกขอวีซ่า ต้องกรอกที่ไหน",
        answer : <span>กรอกที่ <a target='_blank' rel="noreferrer" href='https://www.visaforchina.cn/'>www.visaforchina.cn</a></span>,
    },
    {
        type : TYPE_VISA,
        question : "กรอกข้อมูลขอวีซ่าอย่างไร",
        answer : <span>ทำตามขั้นตอนต่อไปนี้ <a target='_blank' rel="noreferrer" href='https://drive.google.com/file/d/1dpRb6RTlHlAKJKIQ9eApsQeaz2_VlIOt/view?usp=sharing '>คู่มือการขอวีซ่า</a></span>,
    },
    {
        type : TYPE_VISA,
        question : "ค่าธรรมเนียมในการทำวีซ่าเท่าไหร่",
        answer : "เข้า-ออก 1 ครั้ง 1,800 บาท (ล่าสุด 18 ต.ค. 2565)",
    },
    {
        type : TYPE_VISA,
        question : "ข้อมูลวีซ่า (Visa Details) ข้อที่ 2.2 ต้องกรอกอย่างไร",
        answer : [
            "2.2 A Validity of visa (months): จำนวนเดือนที่เหลือก่อนจบการศึกษา",
            "2.2 B Maximum duration of longest stay (days): 365 x ปีที่เหลือก่อนจบการศึกษา",
            "2.2 C Entries: Single"
        ],
    },
    {
        type : TYPE_VISA,
        question : "ข้อมูลการเดินทางเข้า (Itinerary) ข้อที่ 6.1 ต้องกรอกอย่างไร",
        answer : [
            "6.1 B Number of arrival train / ship / flight: TG8122",
            "6.1 C City of arrival: Guangzhou",
            "6.1 D County of arrival: Baiyun Qu",
        ],
    },
    {
        type : TYPE_VISA,
        question : "ข้อมูลจุดหมายปลายทาง (Destinations) ข้อที่ 6.1 J-N ต้องกรอกอย่างไร",
        answer : [
            "6.1 J City: เมืองปลายทางสุดท้าย (ตรวจสอบกับมหาวิทยาลัย)",
            "6.1 K County: เขตที่จะอาศัยอยู่ (ตรวจสอบกับมหาวิทยาลัย)",
            "6.1 M Address: ที่อยู่ (ตรวจสอบกับมหาวิทยาลัย)",
            "6.1 L Date of arrival: วัน เดือน ปีที่ถึงเมืองปลายทาง",
            "6.1 N Date of departure: วัน เดือน ปีที่ออกจากเมืองปลายทาง",
        ],
    },
    {
        type : TYPE_VISA,
        question : "ข้อมูลการเดินทางออกจากประเทศจีน ข้อที่ 6.1 E-G ต้องกรอกอย่างไร",
        answer : [
            "6.1 E Intended date of departure: วัน เดือน ปีที่เดินทางออกจากประเทศจีน",
            "6.1 F Number of departure train / ship / flight: n/a",
            "6.1 G City of departure: เมืองที่จะเดินทางออกจากประเทศจีน",
            "6.1 H County of departure: เขตที่จะเดินทางออกจากประเทศจีน",
        ],
    },
    {
        type : TYPE_VISA,
        question : "ผู้ส่งคำเชิญ (Inviting person or organization in China) ข้อที่ 6.2 ต้องกรอกอย่างไร",
        answer : "อ้างอิงข้อมูลของมหาวิทยาลัยหรือบุคคลที่ดูแลคุณเมื่ออยู่ ณ ประเทศจีน",
    },
    {
        type : TYPE_VISA,
        question : "จำเป็นต้องพิมพ์หลักฐานการกรอกด้วยหรือไม่",
        answer : "จำเป็น เพราะทางศูนย์วีซ่าต้องการเอกสารดังกล่าวประกอบการพิจารณา",
    },
    {
        type : TYPE_VISA,
        question : "กรณีที่เดินทางกับสมาคมฯ ต้องจองคิวหรือไม่",
        answer : "เฉพาะศูนย์ที่กรุงเทพฯ ไม่ต้องจองคิว ทางสมาคมจะประสานกับศูนย์วีซ่าให้",
    },
    {
        type : TYPE_VISA,
        question : "กรณีที่ไม่สะดวกในช่วงเวลาที่ทางสมาคมฯ จัดสรรให้สามารถทำอย่างไรได้บ้าง",
        answer : "สอบถามผู้ที่จะไปทำวีซ่า ณ ที่เดียวกันเพื่อสลับเวลา",
    },
    {
        type : TYPE_VISA,
        question : "กรณีที่ไม่สะดวกในวันที่ทางสมาคมฯ จัดสรรให้สามารถทำอย่างไรได้บ้าง",
        answer : "แจ้งทีมงานประจำเที่ยวบินที่เกี่ยวข้องและจองคิวกับทางศูนย์วีซ่าด้วยตนเอง",
    },
    {
        type : TYPE_VISA,
        question : "ไม่สะดวกไปรับวีซ่าด้วยตนเองต้องทำอย่างไร",
        answer : "ฝากใบรับวีซ่าให้ผู้ที่ไว้ใจดำเนินการแทน โดยไม่จำเป็นต้องเขียนจดหมายมอบอำนาจ",
    },
    {
        type : TYPE_VISA,
        question : "ผู้ที่ไปรับวีซ่าแทนไม่มีใบรับได้หรือไม่",
        answer : "ไม่ได้ หากใบรับหายให้แจ้งทีมงานประจำเที่ยวบินและรีบดำเนินการติดต่อศูนย์วีซ่า",
    },



    {
        type : TYPE_MAOLAM,
        question : "น้ำหนักของสัมภาระจำกัดไว้กี่กิโลกรัม กี่ใบ",
        answer : [
            "ชั้นประหยัด (Economy Class) 30 กิโลกรัม",
            "ชั้นธุรกิจ (Business Class) 40 กิโลกรัม",
            "สัมภาระไม่เกิน 3 ใบ ไม่รวมถือสัมภาระถือขึ้นเครื่อง"
        ],
    },
    {
        type : TYPE_MAOLAM,
        question : "สัมภาระถือขึ้นเครื่องจำกัดไว้กี่กิโลกรัม กี่ใบ",
        answer : "7 กิโลกรัม ไม่เกิน 2 ใบ (กระเป๋าถือ 1 ใบและกระเป๋าสะพายหลัง 1 ใบ) หรือตามมาตรการสากล",
    },
    {
        type : TYPE_MAOLAM,
        question : "สามารถเช็คอินออนไลน์ได้หรือไม่",
        answer : "ไม่ได้ เนื่องจากเที่ยวบินของสมาคมฯ เป็นเที่ยวบินเหมาลำซึ่งใช้ระบบต่างจากเที่ยวบินทั่วไป",
    },
    {
        type : TYPE_MAOLAM,
        question : "สามารถซื้อน้ำหนักเพิ่มหรือจัดสัมภาระให้น้ำหนักเกินเล็กน้อยได้หรือไม่",
        answer : "ไม่ได้ สมาคมฯ ไม่มีนโยบายจำหน่ายน้ำหนักเพิ่มหรืออนุญาตให้โหลดสัมภาระน้ำหนักเกิน ซึ่งเที่ยวบินก่อนหน้าผู้ที่จัดสัมภาระเกินต้องนำสิ่งของออกหรือแบ่งน้ำหนักกับผู้อื่นจนอยู่ในเกณฑ์",
    },
    {
        type : TYPE_MAOLAM,
        question : "กรณีที่น้ำหนักเกินสามารถแบ่ง/หารน้ำหนักกับผู้อื่นได้หรือไม่",
        answer : "ได้ แต่เวลาเช็คอินต้องต่อแถวด้วยกันและแจ้งเจ้าหน้าที่ที่เกี่ยวข้องให้ทราบ ทั้งนี้ไม่สามารถแบ่งน้ำหนักข้ามประเภทตั๋วได้",
    },
    {
        type : TYPE_MAOLAM,
        question : "อยากนั่งกับเพื่อนต้องทำอย่างไร",
        answer : "เลือกที่นั่งผ่านทางเว็บไซต์ของการบินไทย โดยห้ามลบข้อมูลของผู้อื่นเนื่องจากเป็นการจองแบบกลุ่ม หรือต่อแถวเช็คอินพร้อมเพื่อน",
    },
    {
        type : TYPE_MAOLAM,
        question : "จะได้ตั๋วเครื่องบินวันไหน",
        answer : "2-3 วันก่อนเดินทาง",
    },
    {
        type : TYPE_MAOLAM,
        question : "สามารถนำครอบครัวหรือเพื่อนไปส่งที่ท่าอากาศยานได้หรือไม่",
        answer : "ได้ แต่ไม่อนุญาตให้เข้ามาบริเวณแถวเช็คอิน และไม่อนุญาตให้ถอดหน้ากาก ถุงมือ หรือชุด PPE",
    },
    {
        type : TYPE_MAOLAM,
        question : "ควรไปถึงประตูขึ้นเครื่องก่อนกำหนดเวลากี่นาที",
        answer : "30 นาทีหรือขึ้นอยู่กับการนัดหมายจากทีมงานประจำเที่ยวบินนั้น ๆ ทั้งนี้เที่ยวบินเหมาลำจะไม่มีการประกาศเรียกชื่อขึ้นเครื่อง (Final call)",
    },
    
]

const PageFaq = () => {

    return (
        <div>
            <BlockContainer>
                <div className="h5 bold text-center">คำถามที่พบบ่อย</div>
                <div className="h5 bold text-center">Frequent Asked Questions</div>
                <br />
                {[TYPE_SYSTEM, TYPE_VISA, TYPE_MAOLAM].map((type, index) => (
                    <div key={index}>
                        <div className="bold">{type}</div>
                        <br />
                        {QuestionList.filter(v => v.type === type).map((list, index) => (
                            <RenderQuestion key={index} question={`${index + 1}. ${list.question}`} answer={list.answer} />
                        ))}
                    </div>
                ))}
            </BlockContainer>
        </div>
    )
}

const RenderQuestion = props => {
    const { question, answer } = props
    return (
        <div style={{paddingLeft : '20px'}}>
            <div style={{paddingBottom : '10px'}}>{question}</div>
            <div>
                {Array.isArray(answer) ? answer.map((a, i) => (
                    <div key={i}>{ICON_ANSWER}{a}</div>
                )) : <>{ICON_ANSWER}{answer}</>}
            </div>
            <hr />
        </div>
    )
}

export default PageFaq;